import {Component, inject, OnInit} from "@angular/core";
import {ErrorWrapper, ErrorWrapperFactory, SecurityTradesSummariesList, TradesService} from "@kwsoft/otcx-core";

const PAGE_SIZE = 5;

@Component({
    selector: "otcx-home-securities-active",
    templateUrl: "./home-securities-active.component.html",
    styleUrls: ["./home-securities-active.component.scss"],
    standalone: false
})
export class HomeSecuritiesActiveComponent implements OnInit {
    securitiesListLoader: ErrorWrapper<SecurityTradesSummariesList>;

    private readonly tradesService = inject(TradesService);
    private readonly errorWrapperFactory = inject(ErrorWrapperFactory<SecurityTradesSummariesList>);

    ngOnInit(): void {
        this.securitiesListLoader = this.errorWrapperFactory.wrap(
            this.tradesService.getTradesBySecurityWithinPeriod(PAGE_SIZE));
    }

}
